(function(EF) {

  var ActionPlanTopic = Chaplin.Model.extend({});

  _.extend(EF.Models, {
    ActionPlanTopic: ActionPlanTopic
  });

}(EF));
